module.exports = "<p>\n  smtp works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/smtp/smtp.component.html
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/smtp/smtp.component.html
// module chunks = main